import React from 'react';
import { PropTypes } from 'prop-types';
import isNullOrWhiteSpace from 'common/App/isNullOrWhiteSpace';

const CustomerJotrCard = ({ jotr, jurisdictions, showActions, onMakePrimary, onMakeWhd }) => {
  const getJurisdictionName = (country) => {
    if (country && jurisdictions && jurisdictions.length > 0) {
      const matches = jurisdictions.filter(x => x.code === country || x.name === country);
      if (matches && matches.length > 0) {
        return `${ matches[0].name } (${ matches[0].code })`;
      }
    }
    return country != null && country !== '' ? country : 'N/A';
  };

  const onMakePrimaryClick = () => {
    if (onMakePrimary) {
      onMakePrimary(jotr);
    }
  };

  const onMakeWhdClick = () => {
    if (onMakeWhd) {
      onMakeWhd(jotr);
    }
  };

  return (<div className="customer-jotr-card">
    <div className="columns">
      <div className="col-9">
        <div className="jotr mb">
          <span>{ getJurisdictionName(jotr.countryIsoCode ?? jotr.country) }</span>
        </div>
        <div className="jotr">
          { !isNullOrWhiteSpace(jotr.tin) && <span>{jotr.tin}</span> }
          { (isNullOrWhiteSpace(jotr.tin) && !isNullOrWhiteSpace(jotr.noTinReason)) && <span>No TIN Reason - {jotr.noTinReason}</span> }
        </div>
        { (isNullOrWhiteSpace(jotr.tin) && !isNullOrWhiteSpace(jotr.noTinReason) && !isNullOrWhiteSpace(jotr.noTinExplanation)) && <div className="jotr">
          <span>{jotr.noTinExplanation}</span>
        </div> }
      </div>
      <div className="col-3 pills">
        {jotr.isPrimary && <div className="chip chip--active mb" title="This Tax Residence is used for Presumption Rules, US indicia">PRIMARY</div>}
        { showActions && !jotr.isPrimary && <button type="button" className="btn btn-link mb" onClick={ () => onMakePrimaryClick() }>
          <span className="chip chip--active chip--primary--inactive mb" title="Click here to make this Tax Residence the Primary">MAKE PRIMARY</span>
        </button>}
        {jotr.isWithholdingResidence && <div className="chip chip--whd" title="This Tax Residence is used for Withholding Calculations">WHD</div>}
        { /* eslint-disable-next-line no-bitwise */ }
        { showActions && !jotr.isWithholdingResidence && (jotr.regime & 1) === 1 && <button type="button" className="btn btn-link" onClick={ () => onMakeWhdClick() }>
          <span className="chip chip--whd chip--whd--inactive" title="Click here to use this Tax Residence for withholding calculations">MAKE WHD</span>
        </button>}
      </div>
    </div>
  </div>);
};

CustomerJotrCard.propTypes = {
  jotr: PropTypes.shape().isRequired,
  jurisdictions: PropTypes.arrayOf(PropTypes.shape),
  showActions: PropTypes.bool,
  onMakePrimary: PropTypes.func,
  onMakeWhd: PropTypes.func
};

CustomerJotrCard.defaultProps = {
  jurisdictions: null,
  showActions: false,
  onMakePrimary: null,
  onMakeWhd: null
};

export default CustomerJotrCard;
